<template>
  <div v-click-outside="hideOptions" class="relative" :class="variantCls.root">
    <!-- Tags -->
    <div
      v-if="tags.length > 0"
      class="flex flex-wrap"
      :class="variantCls.tagRoot"
    >
      <div
        v-for="(tag, idx) in tags"
        :key="tag[valueKey]"
        class="inline"
        :class="variantCls.tag"
      >
        <span>{{ tag[nameKey] }}</span>
				<span class="cursor-pointer" @click.stop="removeTag(idx)">
					&times;
				</span>      
        </div>
    </div>

    <!-- Input -->
    <input
      v-model="searchTerm"
      :class="variantCls.input"
      :placeholder="placeholder"
			:disabled="disabled"
      @input="$emit('search', searchTerm)"
      @focus="handleFocus"
      @blur="emit('blur')"
    />

    <!-- Options -->
    <Transition
      :enter-class="variantCls.Transition.enter"
      :enter-active-class="variantCls.Transition.enterActive"
      :leave-active-class="variantCls.Transition.leaveActive"
      :leave-to-class="variantCls.Transition.leave"
    >
      <div
        v-if="options.length > 0 && showOptions"
        style="max-height: 12rem; left: -1px; right: -1px"
        class="absolute overflow-y-auto z-10"
        :class="variantCls.options"
      >
        <div
          v-for="option in filteredOptions"
          :key="option[valueKey]"
          class="option"
          @click="onOptionClick(option)"
        >
          <slot :name="`option-${option[valueKey]}`">
	          <p class="" :class="variantCls.option">
							{{ option[nameKey] }}
						</p>          
            </slot>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "JMultiSelect",
  props: {
    variant: {
      type: String,
      default: "default"
    },
    nameKey: {
      type: String,
      default: "name"
    },
    valueKey: {
      type: String,
      default: "value"
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "Please select"
		},
		disabled: {
			type: Boolean,
			default: false
    }
  },
  data() {
    return {
      tags: [],
      searchTerm: "",
      showOptions: false
    }
  },
  computed: {
    filteredOptions() {
      if (!this.searchTerm) return this.options
			const filteredOptions = this.options.filter(item => {
        if (
          item &&
          item[this.nameKey] &&
          item[this.nameKey]
            .toLowerCase()
            .includes(this.searchTerm.toLowerCase())
        )
          return true
      })
      return filteredOptions
    },
    variantCls() {
      const defaultVariants = {
        root: "",
        tagRoot: "",
        tag: "",
        input: "",
        options: "",
        option: "",
        Transition: {
          enter: "",
          enterActive: "",
          leave: "",
          leaveActive: ""
        }
      }
      const variantCls = this.$store.getters.variants(
        "JMultiSelect",
        this.variant
      ).el
      return variantCls === {}
        ? defaultVariants
        : { ...defaultVariants, ...variantCls }
    }
  },
  watch: {
    value: {
      handler() {
        this.tags = this.value || []
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleFocus() {
      if (!this.disabled) {
        this.$emit("focus")
        this.toggleOptions(true)
      }
    },
    emit(...args) {
      if (!this.disabled) {
        this.$emit(...args)
      }
    },
    toggleOptions(value) {
      if (value === undefined) this.showOptions = !this.showOptions
      this.showOptions = value
    },
    hideOptions() {
      this.toggleOptions(false)
    },
    onOptionClick(option) {
      this.addTag(option)
      this.toggleOptions(false)
      this.searchTerm = ""
      this.$emit("input", this.tags)
    },
    addTag(tag) {
			if (this.tags.find(t => t[this.valueKey] === tag[this.valueKey])) return
      this.tags.push(tag)
    },
    removeTag(idx) {
			if (this.disabled) return
      this.tags.splice(idx, 1)
      this.$emit("input", this.tags)
    }
  }
}
</script>